import { createFileRoute } from '@tanstack/react-router';
import { Option, Schema } from 'effect';
import { ConnectionPage } from '../../../../receptora/connection/connection-page.tsx';
import { RETURN_NOTICES } from '../../../../receptora/journey/return-page.tsx';

// What the transmitter's return left for the detail to say: a refusal or an error, never more.
const connectionSearch = Schema.toStandardSchemaV1(
  Schema.Struct({ result: Schema.optionalKey(Schema.Literals(RETURN_NOTICES)) }),
);

// Declared inline: the route plugin splits `component` into a lazy binding it declares after the
// options, so an options object declared on its own reads that binding before it exists in dev.
// The journey test mounts `Route.options` (real `validateSearch`, real component) instead.
export const Route = createFileRoute('/receptora/conexoes/$id')({
  validateSearch: connectionSearch,
  component: ConnectionRoute,
});

function ConnectionRoute(): JSX.Element {
  const { id } = Route.useParams();
  const { result } = Route.useSearch();
  return <ConnectionPage id={id} returned={Option.fromUndefinedOr(result)} />;
}
